<template lang="pug">
  .status.toggle.component
    toggle( v-model='article.publish' color='blue' )
    label {{ article.publish ? 'Published' : 'Draft' }}
</template>

<script>
  import Toggle from 'vue-switches'

  export default {
    name: 'status.toggle.component',

    components: {
      Toggle
    },

    props: {
      article: { type: Object, required: true }
    }
  }
  
</script>

<style lang="stylus" scoped>
  .status
    text-align center
    margin-top 32px
    display flex
    justify-content center
    align-items center
    flex-direction column
    label
      margin-top 12px
      font-size .88em
      font-weight 400
</style>